// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610160728/js/" + chunkId + "." + {"44":"08ede703","225":"82892142","481":"c20f8cb1","486":"6b041621","770":"0dd699fe"}[chunkId] + ".0.34941621064232575.chunk.js";
};